import { useState } from "react";

/**
 * Shared media container for article images & videos.
 * - Reserves space before load (placeholder aspect) so text never jumps.
 * - After load, adopts the media's natural aspect ratio (no crop/stretch).
 * - Caps height for portrait media (`maxVh`) and centers it on a soft backdrop.
 */
export function useNaturalAspect(fallback = "16 / 10") {
    const [ratio, setRatio] = useState(null);
    const onDims = (w, h) => { if (w > 0 && h > 0) setRatio(`${w} / ${h}`); };
    return { aspect: ratio || fallback, portrait: ratio ? parseFloat(ratio) < 1 : false, onDims, loaded: !!ratio };
}

export default function MediaFrame({ aspect, portrait, loaded, maxVh = 70, className = "", children, ...rest }) {
    // Landscape: full width, height follows ratio. Portrait: width derived from a
    // viewport-capped height (ratio always preserved, never wider than the column).
    const [aw, ah] = String(aspect).split("/").map((x) => parseFloat(x));
    const r = aw > 0 && ah > 0 ? aw / ah : 1;
    const style = { aspectRatio: aspect, width: `min(100%, calc(min(${maxVh}vh, 720px) * ${r.toFixed(4)}))`, marginInline: "auto" };
    return (
        <div
            className={`media-frame ${portrait ? "media-frame--portrait" : ""} ${loaded ? "media-frame--loaded" : ""} ${className}`}
            style={style}
            {...rest}
        >
            {children}
        </div>
    );
}
